import { render, staticRenderFns } from "./OrderInfoDia.vue?vue&type=template&id=3149a0a8&scoped=true"
import script from "./OrderInfoDia.vue?vue&type=script&lang=js"
export * from "./OrderInfoDia.vue?vue&type=script&lang=js"
import style0 from "./OrderInfoDia.vue?vue&type=style&index=0&id=3149a0a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3149a0a8",
  null
  
)

export default component.exports